import * as _ from 'lodash';
import { BaseAPIService } from './base-api.service';

export class BaseEntityService<T> extends BaseAPIService {
    constructor(private readonly entityConstructor: (data) => T) {
        super();
    }

    initEntities(dataSet: any): T[] {
        return Array.isArray(dataSet) ? dataSet.map(data => this.initEntity(data)) : [];
    }

    initEntity(data: any): T {
        return this.entityConstructor(data);
    }

    initIfDataExists(data: any): T {
        return data ? this.initEntity(data) : null;
    }
}
